const faqInit = () => {
  const faqLists = document.querySelectorAll('.faq .faq__inner .faq__list');
  if (faqLists) {
    faqLists.forEach((lists) => {
      const items = lists.querySelectorAll('.faq__item');
      if (items) {
        items.forEach((item, index) => {
          const trigger = item.querySelector('.faq__list-title');
          const dropdown = item.querySelector('.faq__content') as HTMLElement;
          const dropdownInner = item.querySelector('.faq__content-inner') as HTMLElement;
          const dropdownHeight = dropdownInner.clientHeight;

          // set first with class --active
          if (index === 0) {
            item.classList.add('faq__item--active');
            dropdown.style.setProperty('height', `${dropdownHeight}px`);
          }

          trigger.addEventListener('click', () => {
            item.classList.toggle('faq__item--active');

            if (item.classList.contains('faq__item--active')) {
              dropdown.style.setProperty('height', `${dropdownHeight}px`);
            } else {
              dropdown.setAttribute('style', 'height:0px;');
            }
          });
        });
      }
    });
  }
};

export default faqInit;
